<!-- {{medicationInvoices | json}} -->
<div class="eighty-twenty w-100 g-just-flex gap-30
align-items-start m-auto
" style="flex-wrap: wrap; max-width: 1280px;
justify-content: flex-start;
">
    <div class="eighty">
        <mat-card>
            <mat-card-header class="g-just-flex flex-wrap gap-20 ecbill" style="justify-content: space-between;">
                <div class="left">
                    <mat-card-title>
                        Patient Bill
                    </mat-card-title>
                    <mat-card-subtitle class="mb-20  subtitle-text-color-2">
                        Manage patient bills effectively.
                    </mat-card-subtitle>
                </div>
                <!-- @if (!isAnyQueryParams) { -->
                <!-- <div class="right" style="display: flex; justify-content: flex-end; flex: 1 1 max-content">
                    <button mat-button (click)="addAnyCharges()">
                        <mat-icon>add</mat-icon>
                        <span>Add Charges</span>
                    </button> -->
                <!-- </div> -->
                <!-- } -->

                <div class="g-just-flex"
                    style="justify-content: flex-end; align-items: center; min-width: max-content;">
                    <button mat-button (click)="addManualCharge('Others')">
                        <mat-icon>add</mat-icon>
                        <span>Add Bills Manually</span>
                    </button>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class=" all-charges g-just-flex gap-20 mb-20 flex-column w-100 ">
                    <!-- {{tableDataSourceMap | json}} -->
                    @for (section of tableDataSourceMap; track section[0]) {
                    <!-- {{section[0] | json}} -->

                    @if(section[0] === 'MedicationDispense'
                    && section[1].data
                    ){

                    <div class=" encounter-sub-charges w-100 g-just-flex gap-12 flex-column">
                        <div class="subcharges-wrapper w-100 g-just-flex gap-0 mb-0 flex-column"
                            style="justify-content: flex-start; align-items: flex-start; margin-top: 20px;">

                            <div class="subcharges-title gap-12 " style="display: flex;
                        justify-content: flex-start; align-items: flex-start;
                        ">
                                <div class="rounded-icon-wrapper g-just-flex" style="background-color: transparent">
                                    <mat-icon style="
                                    background-color: var(--mat-sys-on-primary);
                                    color: var(--mat-sys-primary);">medication</mat-icon>

                                </div>
                                <div class="text-details mb-12">
                                    <div class="order-detail-title" style=" font-weight: 500;
                                        font-size: 1.2rem;">Dispensed Medication
                                        Bills
                                    </div>
                                    <div class=" mb-9" style="
                                        padding: 3px 8px;
    margin: 3px 0px;
    border-radius: 3px;
    background-color: var(--mat-sys-surface-variant);
    color: var(--mat-sys-on-surface);
    width: max-content
    ">
                                        <em>Patient: </em>

                                        <span [appReferenceDisplay]="section[1].data[0].subject?.reference"
                                            [InstantfetchAndRepace]="true"></span>
                                    </div>
                                    <div class="order-detail-items">

                                    </div>
                                </div>
                                <!-- 
                                <div class="g-just-flex"
                                    style="justify-content: flex-end; align-items: center; min-width: max-content;">
                                    <button mat-button (click)="addManualCharge(section[0])">
                                        <mat-icon>add</mat-icon>
                                        <span>Add Manual Charge</span>
                                    </button>
                                </div> -->

                            </div>


                            <mat-card style="width: min-content; max-width: 100%;">
                                <mat-card-header>
                                    <!-- <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
                                        <div class="left">
                                            <mat-card-title>Medication Invoices</mat-card-title>
                                            <mat-card-subtitle>
                                                Invoices linked to medication charge items for this encounter
                                            </mat-card-subtitle>
                                        </div>
                                    </div> -->

                                </mat-card-header>

                                <mat-card-content class="my-12">
                                    <mat-divider></mat-divider>

                                    <div class="table-or-empty" style="background-color: transparent !important;">
                                        @if (section[1].data.length) {
                                        <table style="min-width: 780px; width: unset" mat-table
                                            style="background-color: transparent !important;" [dataSource]="section[1]"
                                            class="mat-elevation-z8 demo-table">

                                            <ng-container matColumnDef="invoice">
                                                <th mat-header-cell *matHeaderCellDef>Invoice</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="restrict-length">{{ row.invoiceIdDisplay }}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="date">
                                                <th mat-header-cell *matHeaderCellDef>Date</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div style="display:flex; flex-direction:column; line-height:1.15;">
                                                        <span style="font-weight:600;">
                                                            {{ row.invoiceDayDisplay }}
                                                        </span>
                                                        <span style="opacity:0.68; font-size: 0.82em;">
                                                            {{ row.invoiceTimeDisplay }}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>Totals</strong>
                                                </td>
                                            </ng-container>
                                            <!-- Price (manual supplement when ChargeItemDefinition is missing) -->
                                            <ng-container matColumnDef="price">
                                                <th mat-header-cell *matHeaderCellDef>Price</th>
                                                <td mat-cell *matCellDef="let row">
                                                    @if (row?.unitPriceValue != null) {
                                                    <div class="price-cell">
                                                        <span>{{ fmtMoney({ value: row.unitPriceValue, currency:
                                                            row?.currency || 'NGN' }) }}</span>
                                                        @if (hasManualPriceOverride(row)) {
                                                        <span class="price-override-flag">Price overridden</span>
                                                        }
                                                    </div>
                                                    } @else {
                                                    <button mat-button
                                                        style="width: max-content; padding: 0px 8px !important;"
                                                        (click)="addPriceForRow(row); $event.stopPropagation()"
                                                        [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                        <mat-icon
                                                            style="width: 16px; height: 16px; font-size: 16px; margin-right: 4px;">add</mat-icon>
                                                        Add price
                                                    </button>
                                                    }
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div [appChips]="row.invoiceStatusDisplay" [fontSize]="'14px'">
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <span style="opacity:0.8;">Paid: {{
                                                        getSectionTotals(section[1]).paidDisplay }}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="medication">
                                                <th mat-header-cell *matHeaderCellDef>Medication</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="restrict-length">
                                                        <div [appReferenceDisplay]="row.medicationDisplay"
                                                            [instantFetchAndReplace]="true"></div>
                                                    </span>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="quantity">
                                                <th mat-header-cell *matHeaderCellDef>Qty</th>
                                                <td mat-cell *matCellDef="let row">
                                                    {{ row.quantityDisplay }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="totalGross">
                                                <th mat-header-cell *matHeaderCellDef>Total</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <strong>{{ row.totalGrossDisplay }}</strong>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>{{ getSectionTotals(section[1]).totalGrossDisplay
                                                        }}</strong>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef></th>
                                                <td mat-cell *matCellDef="let row">
                                                    <button mat-icon-button [matMenuTriggerFor]="rowMenu"
                                                        (click)="$event.stopPropagation()" aria-label="More actions">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #rowMenu="matMenu">
                                                        <button mat-menu-item (click)="viewInvoiceRow(row)">
                                                            <mat-icon>visibility</mat-icon>
                                                            <span>View</span>
                                                        </button>
                                                        @if(canManageBilling()) {
                                                        <button mat-menu-item (click)="markInvoiceAsPaid(row)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>task_alt</mat-icon>
                                                            <span>Mark as paid</span>
                                                        </button>
                                                        <button mat-menu-item (click)="addPriceForRow(row, true)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>price_change</mat-icon>
                                                            <span>Override price</span>
                                                        </button>
                                                        @if(row.status === 'balanced'){
                                                        <button mat-menu-item (click)="reversePayment(row)">
                                                            <mat-icon>refresh</mat-icon>
                                                            <span>Reverse Payment</span>
                                                        </button>
                                                        }
                                                        }
                                                    </mat-menu>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="medicationInvoiceDisplayedColumns"
                                                matHeaderRowDefSticky="true">
                                            </tr>
                                            <tr mat-row
                                                *matRowDef="let row; columns: medicationInvoiceDisplayedColumns;"></tr>

                                            <tr mat-footer-row *matFooterRowDef="medicationInvoiceDisplayedColumns">
                                            </tr>
                                        </table>
                                        } @else {
                                        <div class="g-just-flex flex-column align-items-center py-40"
                                            style="text-align:center;">
                                            <app-empty-state [icon]="'receipt_long'" [title]="'No Medication Bills'"
                                                [subtitle]="'No medication-related invoices found for this encounter.'">
                                            </app-empty-state>
                                        </div>
                                        }
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <!-- <div class="w-100 g-just-flex" style="justify-content: flex-end; align-items: center;">
                                <button mat-button (click)="addMedicationCharges()">
                                    <mat-icon>add</mat-icon>
                                    <span>Add More Medication Charges</span>
                                </button>
                            </div> -->
                        </div>
                    </div>
                    }



                    <!-- {{section[0]}} -->

                    @if(
                    (section[0] === 'Laboratory' || section[0] === 'laboratory')
                    && section[1].data
                    ){
                    <div class="encounter-sub-charges w-100 g-just-flex gap-12 flex-column">
                        <div class="subcharges-wrapper w-100 g-just-flex gap-0 mb-0 flex-column"
                            style="justify-content: flex-start; align-items: flex-start; margin-top: 20px;">

                            <div class="subcharges-title gap-12 " style="display: flex;
                        justify-content: flex-start; align-items: center;
                        ">
                                <div class="rounded-icon-wrapper g-just-flex" style="background-color: transparent">
                                    <mat-icon style="
                                    background-color: var(--mat-sys-on-primary);
                                    color: var(--mat-sys-primary);">biotech</mat-icon>

                                </div>
                                <div class="text-details">
                                    <div class="order-detail-title" style="
                                        color: var(--mat-sys-primary); font-weight: 500;
                                        font-size: 1.2rem;">Laboratory Bills

                                    </div>
                                    <div class=" mb-9" style="
                                        padding: 3px 8px;
    margin: 3px 0px;
    border-radius: 3px;
    background-color: var(--mat-sys-surface-variant);
    color: var(--mat-sys-on-surface);
    width: max-content
    ">
                                        <em>Patient: </em>

                                        <span [appReferenceDisplay]="section[1].data[0].subject?.reference"
                                            [InstantfetchAndRepace]="true"></span>
                                    </div>
                                    <div class="order-detail-items">

                                    </div>
                                </div>

                                <!-- <div class="g-just-flex"
                                    style="justify-content: flex-end; align-items: center; min-width: max-content;">
                                    <button mat-button (click)="addManualCharge(section[0])">
                                        <mat-icon>add</mat-icon>
                                        <span>Add Manual Charge</span>
                                    </button>
                                </div> -->

                            </div>
                            <mat-card style="width: min-content; max-width: 100%;">
                                <mat-card-content class="my-12">
                                    <mat-divider></mat-divider>

                                    <div class="table-or-empty" style="background-color: transparent !important;">
                                        @if (section[1].data.length) {
                                        <table style="min-width: 780px; width: unset" mat-table
                                            style="background-color: transparent !important;" [dataSource]="section[1]"
                                            class="mat-elevation-z8 demo-table">

                                            <ng-container matColumnDef="date">
                                                <th mat-header-cell *matHeaderCellDef>Date</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div style="display:flex; flex-direction:column; line-height:1.15;">
                                                        <span style="font-weight:600;">{{ row.invoiceDayDisplay
                                                            }}</span>
                                                        <span style="opacity:0.68; font-size: 0.82em;">{{
                                                            row.invoiceTimeDisplay }}</span>
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>Totals</strong>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div [appChips]="row.invoiceStatusDisplay" [fontSize]="'14px'">
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <span style="opacity:0.8;">Paid: {{
                                                        getSectionTotals(section[1]).paidDisplay }}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="service">
                                                <th mat-header-cell *matHeaderCellDef>Test</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="restrict-length">{{ row.serviceDisplay || 'N/A'
                                                        }}</span>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="unitPrice">
                                                <th mat-header-cell *matHeaderCellDef>Unit Price</th>
                                                <td mat-cell *matCellDef="let row">{{ row['unit price'] || 'N/A' }}</td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="quantity">
                                                <th mat-header-cell *matHeaderCellDef>Qty</th>
                                                <td mat-cell *matCellDef="let row">{{ row.quantityDisplay }}</td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="totalGross">
                                                <th mat-header-cell *matHeaderCellDef>Total</th>
                                                <td mat-cell *matCellDef="let row"><strong>{{ row.totalGrossDisplay
                                                        }}</strong></td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>{{ getSectionTotals(section[1]).totalGrossDisplay
                                                        }}</strong>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="price">
                                                <th mat-header-cell *matHeaderCellDef>Price</th>
                                                <td mat-cell *matCellDef="let row">
                                                    @if (row?.unitPriceValue != null) {
                                                    <div class="price-cell">
                                                        <span>{{ fmtMoney({ value: row.unitPriceValue, currency:
                                                            row?.currency || 'NGN' }) }}</span>
                                                        @if (hasManualPriceOverride(row)) {
                                                        <span class="price-override-flag">Price overridden</span>
                                                        }
                                                    </div>
                                                    } @else {
                                                    <button mat-button
                                                        style="width: max-content; padding: 0px 8px !important;"
                                                        (click)="addPriceForRow(row); $event.stopPropagation()"
                                                        [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                        <mat-icon
                                                            style="width: 16px; height: 16px; font-size: 16px; margin-right: 4px;">add</mat-icon>
                                                        Add price
                                                    </button>
                                                    }
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef></th>
                                                <td mat-cell *matCellDef="let row">
                                                    <button mat-icon-button [matMenuTriggerFor]="rowMenu"
                                                        (click)="$event.stopPropagation()" aria-label="More actions">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #rowMenu="matMenu">
                                                        <button mat-menu-item (click)="viewInvoiceRow(row)">
                                                            <mat-icon>visibility</mat-icon>
                                                            <span>View</span>
                                                        </button>
                                                        @if(canManageBilling()) {
                                                        <button mat-menu-item (click)="markInvoiceAsPaid(row)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>task_alt</mat-icon>
                                                            <span>Mark as paid</span>
                                                        </button>
                                                        <button mat-menu-item (click)="addPriceForRow(row, true)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>price_change</mat-icon>
                                                            <span>Override price</span>
                                                        </button>
                                                        @if(row.status === 'balanced'){
                                                        <button mat-menu-item (click)="reversePayment(row)">
                                                            <mat-icon>refresh</mat-icon>
                                                            <span>Reverse Payment</span>
                                                        </button>
                                                        }
                                                        }
                                                    </mat-menu>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="labInvoiceDisplayedColumns"
                                                matHeaderRowDefSticky="true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: labInvoiceDisplayedColumns;"></tr>
                                            <tr mat-footer-row *matFooterRowDef="labInvoiceDisplayedColumns"></tr>
                                        </table>
                                        } @else {
                                        <div class="g-just-flex flex-column align-items-center py-40"
                                            style="text-align:center;">
                                            <app-empty-state [icon]="'receipt_long'" [title]="'No Laboratory Invoices'"
                                                [subtitle]="'No laboratory-related invoices found for this encounter.'">
                                            </app-empty-state>
                                        </div>
                                        }
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <!-- <div class="w-100 g-just-flex" style="justify-content: flex-end; align-items: center;">
                                <button mat-button (click)="addLabCharges()">
                                    <mat-icon>add</mat-icon>
                                    <span>Add More Lab Test Charges</span>
                                </button>
                            </div> -->


                        </div>
                    </div>
                    }



                    @if(
                    section[0] !== 'MedicationDispense'
                    && section[0] !== 'Laboratory'
                    && section[0] !== 'laboratory'

                    && section[1].data
                    ){
                    <div class=" encounter-sub-charges w-100 g-just-flex gap-12 flex-column">
                        <div class="subcharges-wrapper w-100 g-just-flex gap-0 mb-0 flex-column"
                            style="justify-content: flex-start; align-items: flex-start; margin-top: 20px;">

                            <div class="subcharges-title gap-12"
                                style="display:flex; justify-content:flex-start; align-items:center;">
                                <div class="rounded-icon-wrapper g-just-flex" style="background-color: transparent">
                                    <mat-icon style="
                                    background-color: var(--mat-sys-on-primary);
                                    color: var(--mat-sys-primary);">receipt_long</mat-icon>
                                </div>
                                <div class="text-details">
                                    <div class="order-detail-title"
                                        style="color: var(--mat-sys-primary); font-weight: 500; font-size: 1.2rem;">
                                        {{ section[0] | titlecase }} Bills
                                    </div>
                                    <div class=" mb-9" style="
                                        padding: 3px 8px;
    margin: 3px 0px;
    border-radius: 3px;
    background-color: var(--mat-sys-surface-variant);
    color: var(--mat-sys-on-surface);
    width: max-content
    ">
                                        <em>Patient: </em>

                                        <span [appReferenceDisplay]="section[1].data[0].subject?.reference"
                                            [InstantfetchAndRepace]="true"></span>
                                    </div>
                                </div>

                                <!-- 
                                <div class="g-just-flex"
                                    style="justify-content: flex-end; align-items: center; min-width: max-content;">
                                    <button mat-button (click)="addManualCharge(section[0])">
                                        <mat-icon>add</mat-icon>
                                        <span>Add Manual Charge</span>
                                    </button>
                                </div> -->
                            </div>

                            <mat-card style="width: min-content; max-width: 100%;">
                                <mat-card-content class="my-12">
                                    <mat-divider></mat-divider>

                                    <div class="table-or-empty" style="background-color: transparent !important;">
                                        @if (section[1].data.length) {
                                        <table style="min-width: 780px; width: unset" mat-table
                                            style="background-color: transparent !important;" [dataSource]="section[1]"
                                            class="mat-elevation-z8 demo-table">

                                            <ng-container matColumnDef="date">
                                                <th mat-header-cell *matHeaderCellDef>Date</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div style="display:flex; flex-direction:column; line-height:1.15;">
                                                        <span style="font-weight:600;">{{ row.invoiceDayDisplay
                                                            }}</span>
                                                        <span style="opacity:0.68; font-size: 0.82em;">{{
                                                            row.invoiceTimeDisplay }}</span>
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>Totals</strong>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <div [appChips]="row.invoiceStatusDisplay" [fontSize]="'14px'">
                                                    </div>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <span style="opacity:0.8;">Paid: {{
                                                        getSectionTotals(section[1]).paidDisplay }}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="service">
                                                <th mat-header-cell *matHeaderCellDef>Service</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="restrict-length">{{ row.serviceDisplay || 'N/A'
                                                        }}</span>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="quantity">
                                                <th mat-header-cell *matHeaderCellDef>Qty</th>
                                                <td mat-cell *matCellDef="let row">{{ row.quantityDisplay }}</td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="totalGross">
                                                <th mat-header-cell *matHeaderCellDef>Total</th>
                                                <td mat-cell *matCellDef="let row"><strong>{{ row.totalGrossDisplay
                                                        }}</strong></td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <strong>{{ getSectionTotals(section[1]).totalGrossDisplay
                                                        }}</strong>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="price">
                                                <th mat-header-cell *matHeaderCellDef>Price</th>
                                                <td mat-cell *matCellDef="let row">
                                                    @if (row?.unitPriceValue != null) {
                                                    <div class="price-cell">
                                                        <span>{{ fmtMoney({ value: row.unitPriceValue, currency:
                                                            row?.currency || 'NGN' }) }}</span>
                                                        @if (hasManualPriceOverride(row)) {
                                                        <span class="price-override-flag">Price overridden</span>
                                                        }
                                                    </div>
                                                    } @else {
                                                    <button mat-button
                                                        style="width: max-content; padding: 0px 8px !important;"
                                                        (click)="addPriceForRow(row); $event.stopPropagation()"
                                                        [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                        <mat-icon
                                                            style="width: 16px; height: 16px; font-size: 16px; margin-right: 4px;">add</mat-icon>
                                                        Add price
                                                    </button>
                                                    }
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef></th>
                                                <td mat-cell *matCellDef="let row">
                                                    <button mat-icon-button [matMenuTriggerFor]="rowMenu"
                                                        (click)="$event.stopPropagation()" aria-label="More actions">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #rowMenu="matMenu">
                                                        <button mat-menu-item (click)="viewInvoiceRow(row)">
                                                            <mat-icon>visibility</mat-icon>
                                                            <span>View</span>
                                                        </button>
                                                        @if(canManageBilling()) {
                                                        <button mat-menu-item (click)="markInvoiceAsPaid(row)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>task_alt</mat-icon>
                                                            <span>Mark as paid</span>
                                                        </button>
                                                        <button mat-menu-item (click)="addPriceForRow(row, true)"
                                                            [disabled]="(row.invoiceStatusDisplay || '').toLowerCase() === 'balanced'">
                                                            <mat-icon>price_change</mat-icon>
                                                            <span>Override price</span>
                                                        </button>
                                                        @if(row.status === 'balanced'){
                                                        <button mat-menu-item (click)="reversePayment(row)">
                                                            <mat-icon>refresh</mat-icon>
                                                            <span>Reverse Payment</span>
                                                        </button>
                                                        }
                                                        }
                                                    </mat-menu>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="otherServiceInvoiceDisplayedColumns"
                                                matHeaderRowDefSticky="true"></tr>
                                            <tr mat-row
                                                *matRowDef="let row; columns: otherServiceInvoiceDisplayedColumns;">
                                            </tr>
                                            <tr mat-footer-row *matFooterRowDef="otherServiceInvoiceDisplayedColumns">
                                            </tr>
                                        </table>
                                        } @else {
                                        <div class="g-just-flex flex-column align-items-center py-40"
                                            style="text-align:center;">
                                            <app-empty-state [icon]="'receipt_long'" [title]="'No Invoices'"
                                                [subtitle]="'No invoices found for this section.'">
                                            </app-empty-state>
                                        </div>
                                        }
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                    }
                    }
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="twenty gap-20 g-just-flex flex-column align-items-start">

        <mat-card class="encounter-summary 
        p-20 pb-15
        g-just-flex flex-column align-items-start">
            <div class="based-on small-subtitle mb-9">
                Based on
            </div>
            <div>
                <div class="info mb-5" style="font-weight: 500;">
                    Encounter: <span [appReferenceDisplay]="'Encounter/' + encounterId"
                    InstantfetchAndRepace="true"
                    ></span>
                </div>
                @let type = incomingQueryParams.type?.toLowerCase();
                @if(!type || (type && type.includes('encounter'))){
                <div class="info-subtitle subtitle-text-color-2" style="line-height: 24px;">
                    These are bills for encounter <span [appReferenceDisplay]="'Encounter/' + encounterId" InstantfetchAndRepace="true"></span>
                </div>
                }
                @else{
                <div class="info-subtitle subtitle-text-color-2" style="line-height: 24px;">

                    These are bills for {{type && type.includes('medicationdispense')?'Medications that are
                    dispensed':(type | titlecase) + ' service(s) carried out'}} during the encounter: <span [appReferenceDisplay]="'Encounter/' + encounterId" InstantfetchAndRepace="true"></span>

                </div>
                }
            </div>
            <!-- <div class="pt-20" style="
            width: 100%;
            border-bottom: 1px solid var(--mat-sys-outline)"></div> -->

            <div class="mb-15"></div>
            @if (incomingQueryParams?.type?.toLowerCase() !== 'all') {
            <a (click)="seeEncounterSummary()" class="g-just-flex gap-12 w-100 justify-content-end " style="cursor: pointer;
            color: var(--mat-sys-primary);
            ">
                <span style="font-weight: 500">See Encounter Summary </span>
                <mat-icon style="vertical-align: middle;">chevron_right</mat-icon>
            </a>
            }


        </mat-card>

        <mat-card class="encounter-summary bill-summary">
            <mat-card-header>
                <mat-card-title>Summary </mat-card-title>
            </mat-card-header>
            <mat-card-content class="mt-12">
                <div class="bill-total-wrapper g-just-flex flex-column gap-12">
                    <div class="abill w-100
                    g-just-flex flex-between
                    ">
                        <div class="words">
                            Total
                        </div>
                        <div class="amount" style="text-align: flex-end;">
                            {{ overallTotalDisplay }}
                        </div>
                    </div>
                    <div style="display:flex; width: 100%;justify-content: flex-end;
                    padding-top: 20px;
                    ">
                        <a class="bill-publish
                        g-just-flex gap-0 
                        ">
                            <div class="px-12 g-just-flex" style="
                            height: 100%;
                            border-right:  1px solid var(--mat-sys-surface); cursor: pointer;"
                                (click)="printInvoiceOrClaim()">{{'Print '+invOrClaim}}
                            </div>


                            <a [mat-menu-trigger-for]="mms" class="g-just-flex mat-select" #se>
                                <mat-icon>arrow_drop_down</mat-icon>

                            </a>
                            <mat-menu #mms="matMenu">

                                <a mat-menu-item value="Invoice" (click)="invOrClaim = 'Invoice'">
                                    Invoice
                                </a>
                                <a mat-menu-item value="Insurance Claim" (click)="invOrClaim = 'Insurance Claim'">
                                    Claim
                                </a>
                            </mat-menu>
                        </a>
                    </div>
                    <!-- retAILILEIFE@GTBank.com -->

                </div>
            </mat-card-content>
        </mat-card>


    </div>

</div>


<!-- 
<div class="each-charges g-just-flex gap-30 flex-wrap"
                                style="justify-content: space-between;">
                                <div class="purchase-details gap-12" style="display: flex;
                        justify-content: flex-start; align-items: center;
                        ">
                                    <div class="rounded-icon-wrapper g-just-flex"
                                        style="background-color: var(--mat-sys-primary)">
                                        <mat-icon style="color: var(--mat-sys-on-primary);">medication</mat-icon>

                                    </div>
                                    <div class="text-details">
                                        <div class="order-detail-title" style="font-size: 1.2rem;">Medication
                                            Dispensed
                                        </div>
                                        <div class="order-detail-items">
                                            Paracetamol 500mg, 10 tablets
                                        </div>
                                    </div>

                                </div>

                                <div class="quantity">
                                    <button class="plus" (click)="increaseQ()">+</button>
                                    <input type="number" name="medication-dispensed" id="" value="1" #q
                                        [(ngModel)]="quantity1">
                                    <button class="minus" (click)="decreaseQ()">-</button>
                                </div>

                                <div class="unit-price">
                                    <div class="ps">
                                        ₦
                                    </div>
                                    <input type="number" name="" id="" #up value="50" [(ngModel)]="medicine1UnitPrice">
                                </div>


                                <div class="total">
                                    <div>{{ (medicine1UnitPrice * quantity1) | priceFormat}}</div>
                                </div> 

</div>-->